import Base from "@/api/Base";

export const ACTION_DEFER = 'defer';
export const ACTION_SEND_OFF = 'send-off';
export const ACTION_SEND_ACCESS_LINK = 'send-access-link';

export default class Modify extends Base
{
	setAppointmentId (v)
	{
		this.appointmentId = v;
		return this;
	}

	setAction (v)
	{
		this.data.action = v;
		return this;
	}

	setAlternativeDates (v)
	{
		this.data.alternativeDates = v;
		return this;
	}

	setCustomerSendOffData (v)
	{
		this.data.customerSendOffData = v;
		return this;
	}

	setApplicantSendOffData (v)
	{
		this.data.applicantSendOffData = v;
		return this;
	}

	setAccessLink (v)
	{
		this.data.accessLink = v;
		return this;
	}

	setAccessLinkUsername (v)
	{
		this.data.accessLinkUsername = v;
		return this;
	}

	setAccessLinkPassword (v)
	{
		this.data.accessLinkPassword = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/kommunikation/termin/' + this.appointmentId;
	}
}
